import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cf34e42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "dropdown__trigger" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "dropdown__title" }, "Шиномонтаж")
], -1))
const _hoisted_3 = { class: "dropdown__content tires" }
const _hoisted_4 = { class: "tires__buttons" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "tires__title" }, "Комплексы", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tires__subtitle" }, "Цена за 4 колеса", -1))
const _hoisted_8 = { class: "tires__item-name" }
const _hoisted_9 = { class: "tires__item-prices" }
const _hoisted_10 = { class: "tires__item-prices-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D10-13", -1))
const _hoisted_12 = { class: "tires__item-prices-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D14", -1))
const _hoisted_14 = { class: "tires__item-prices-row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D15", -1))
const _hoisted_16 = { class: "tires__item-prices-row" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D16", -1))
const _hoisted_18 = { class: "tires__item-prices-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D17", -1))
const _hoisted_20 = { class: "tires__item-prices-row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D18-20", -1))
const _hoisted_22 = { class: "tires__item-prices-row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D21-23", -1))
const _hoisted_24 = { style: {"padding":"0px 20px"} }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "tires__title" }, "Стандартные работы", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tires__subtitle" }, "Стоимость за 1 колесо", -1))
const _hoisted_27 = { class: "tires__item-name" }
const _hoisted_28 = { class: "tires__item-prices" }
const _hoisted_29 = { class: "tires__item-prices-row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D10-13", -1))
const _hoisted_31 = { class: "tires__item-prices-row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D14", -1))
const _hoisted_33 = { class: "tires__item-prices-row" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D15", -1))
const _hoisted_35 = { class: "tires__item-prices-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D16", -1))
const _hoisted_37 = { class: "tires__item-prices-row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D17", -1))
const _hoisted_39 = { class: "tires__item-prices-row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D18-20", -1))
const _hoisted_41 = { class: "tires__item-prices-row" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D21-23", -1))
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "tires__title" }, "Комплексы", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tires__subtitle" }, "Цена за 4 колеса", -1))
const _hoisted_46 = { class: "tires__item-name" }
const _hoisted_47 = { class: "tires__item-prices" }
const _hoisted_48 = { class: "tires__item-prices-row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D10-13", -1))
const _hoisted_50 = { class: "tires__item-prices-row" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D14", -1))
const _hoisted_52 = { class: "tires__item-prices-row" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D15", -1))
const _hoisted_54 = { class: "tires__item-prices-row" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D16", -1))
const _hoisted_56 = { class: "tires__item-prices-row" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D17", -1))
const _hoisted_58 = { class: "tires__item-prices-row" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D18-20", -1))
const _hoisted_60 = { class: "tires__item-prices-row" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D21-23", -1))
const _hoisted_62 = { style: {"paddingBottom":"0px"} }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "tires__title" }, "Стандартные работы", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "tires__subtitle" }, "Стоимость за 1 колесо", -1))
const _hoisted_65 = { class: "tires__item-name" }
const _hoisted_66 = { class: "tires__item-prices" }
const _hoisted_67 = { class: "tires__item-prices-row" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D10-13", -1))
const _hoisted_69 = { class: "tires__item-prices-row" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D14", -1))
const _hoisted_71 = { class: "tires__item-prices-row" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D15", -1))
const _hoisted_73 = { class: "tires__item-prices-row" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D16", -1))
const _hoisted_75 = { class: "tires__item-prices-row" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D17", -1))
const _hoisted_77 = { class: "tires__item-prices-row" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D18-20", -1))
const _hoisted_79 = { class: "tires__item-prices-row" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "D21-23", -1))
const _hoisted_81 = /*#__PURE__*/_createStaticVNode("<ul style=\"padding-top:0px;\" data-v-3cf34e42><li class=\"tires__item\" data-v-3cf34e42><span data-v-3cf34e42>Упаковка в пакет</span><span data-v-3cf34e42>25₽</span></li><li class=\"tires__item\" data-v-3cf34e42><span data-v-3cf34e42>Установка вентиля</span><span data-v-3cf34e42>25₽</span></li><li class=\"tires__item\" data-v-3cf34e42><span data-v-3cf34e42>Установка датчика давления в шинах</span><span data-v-3cf34e42>250₽</span></li><li class=\"tires__item\" data-v-3cf34e42><span data-v-3cf34e42>Герметизация бортов шины</span><span data-v-3cf34e42>100₽</span></li><li class=\"tires__item\" data-v-3cf34e42><span data-v-3cf34e42>Примерка дисков</span><span data-v-3cf34e42>200₽</span></li><li class=\"tires__item\" data-v-3cf34e42><span data-v-3cf34e42>Обработка ступицы специальным спреем</span><span data-v-3cf34e42>125₽</span></li><li class=\"tires__item\" data-v-3cf34e42><span data-v-3cf34e42>Правка диска</span><span data-v-3cf34e42>2.000₽</span></li><li class=\"tires__item\" data-v-3cf34e42><span data-v-3cf34e42>Установка жгута</span><span data-v-3cf34e42>0₽</span></li><li class=\"tires__item\" data-v-3cf34e42><span data-v-3cf34e42>Шлифовка/Чистка тормозного диска</span><span data-v-3cf34e42>0₽</span></li><li class=\"tires__item\" data-v-3cf34e42><span data-v-3cf34e42>Ремонт камеры</span><span data-v-3cf34e42>70₽</span></li><li class=\"tires__item\" data-v-3cf34e42><span data-v-3cf34e42>Ремонт бескамерных шин с установкой грибка</span><span data-v-3cf34e42>310₽</span></li><li class=\"tires__item\" data-v-3cf34e42><span data-v-3cf34e42>Ремонт бескамерных шин с установкой заплаты</span><span data-v-3cf34e42>210₽</span></li></ul>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass(["tires__button", {'tires__button--active': !_ctx.isSUVType}]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setCarTypeToCar && _ctx.setCarTypeToCar(...args)))
        }, "Легковые", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["tires__button", {'tires__button--active': _ctx.isSUVType}]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setCarTypeToSUV && _ctx.setCarTypeToSUV(...args)))
        }, "Suv/Микроавтобусы", 2)
      ]),
      (!_ctx.isSUVType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("ul", null, [
              _hoisted_6,
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.complexTiresWork, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "tires__item",
                  key: index
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(item.name), 1),
                  _createElementVNode("ul", _hoisted_9, [
                    _createElementVNode("li", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[0] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[1] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[2] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[3] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[4] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[5] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[6] + '₽'), 1)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("ul", _hoisted_24, [
              _hoisted_25,
              _hoisted_26,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.standartTiresWork, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "tires__item",
                  key: index
                }, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(item.name), 1),
                  _createElementVNode("ul", _hoisted_28, [
                    _createElementVNode("li", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[0] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[1] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[2] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[3] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_37, [
                      _hoisted_38,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[4] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[5] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_41, [
                      _hoisted_42,
                      _createElementVNode("span", null, _toDisplayString(item.prices.car[6] + '₽'), 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isSUVType)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createElementVNode("ul", null, [
              _hoisted_44,
              _hoisted_45,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.complexTiresWork, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "tires__item",
                  key: index
                }, [
                  _createElementVNode("span", _hoisted_46, _toDisplayString(item.name), 1),
                  _createElementVNode("ul", _hoisted_47, [
                    _createElementVNode("li", _hoisted_48, [
                      _hoisted_49,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[0] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_50, [
                      _hoisted_51,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[1] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[2] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[3] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_56, [
                      _hoisted_57,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[4] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_58, [
                      _hoisted_59,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[5] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_60, [
                      _hoisted_61,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[6] + '₽'), 1)
                    ])
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("ul", _hoisted_62, [
              _hoisted_63,
              _hoisted_64,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.standartTiresWork, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "tires__item",
                  key: index
                }, [
                  _createElementVNode("span", _hoisted_65, _toDisplayString(item.name), 1),
                  _createElementVNode("ul", _hoisted_66, [
                    _createElementVNode("li", _hoisted_67, [
                      _hoisted_68,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[0] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_69, [
                      _hoisted_70,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[1] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_71, [
                      _hoisted_72,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[2] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_73, [
                      _hoisted_74,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[3] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_75, [
                      _hoisted_76,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[4] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_77, [
                      _hoisted_78,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[5] + '₽'), 1)
                    ]),
                    _createElementVNode("li", _hoisted_79, [
                      _hoisted_80,
                      _createElementVNode("span", null, _toDisplayString(item.prices.SUVs[6] + '₽'), 1)
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_81
    ])
  ]))
}